export default function resolveParentEntryTitleFromElement(
  element: Element | null,
) {
  const elValue = element?.getAttribute('data-entry-title')?.trim()
  if (elValue) return elValue

  const nearestParentValue = element
    ?.closest('[data-entry-title]')
    ?.getAttribute('data-entry-title')
    ?.trim()

  if (nearestParentValue) return nearestParentValue

  return undefined
}
